import { SettingsRecencyBiasEndpoint } from '@core/types/types.endpoint.settings';
import { Switch } from '@frontend/components/ui/switch';
import { useDirectoryUpdater } from '@frontend/shared/hooks/shared.hook.useDirectoryUpdater';
import { useDirectoryTeam } from '@frontend/shared/hooks/useDirectory';
import { useSubmitter } from '@frontend/shared/hooks/useSubmitter';
import { callApi } from '@frontend/shared/util/util.callApi';

export function SettingsRecencyBias({
  isReadOnly = false,
}: {
  isReadOnly?: boolean;
}) {
  const team = useDirectoryTeam();
  const updater = useDirectoryUpdater();

  const isChecked = team?.recency_bias ?? true; // Default to true
  const submitter = useSubmitter(async () => {
    const [, res] = await callApi<SettingsRecencyBiasEndpoint>(
      `/settings/recencyBias`,
      {
        recency_bias: !isChecked,
      },
    );
    if (res) {
      updater({
        team: res,
      });
    }
  });

  return (
    <div className="flex items-center">
      <div>
        <h3 className="text-xs font-semibold">Recency Bias</h3>
        <p className="mt-1 text-xs font-medium text-gray-500">
          Prioritize more recent documents in search results. When enabled,
          documents from the last hour, day, week, and month receive higher
          weights in retrieval.
        </p>
      </div>
      <Switch
        className="ml-auto"
        disabled={submitter.isSubmitting || isReadOnly}
        checked={isChecked}
        onCheckedChange={() => {
          if (!isReadOnly) {
            submitter.submit();
          }
        }}
      />
    </div>
  );
}
